import React, { useEffect, useState } from "react";
import images from "../../../Utils/importImages";
import "./MyFlightBookings.css";
import { useDispatch, useSelector } from "react-redux";
import AirlineLogos from "./Components/AirlineLogos";
import Timer from "./Components/Timer";
import { useNavigate } from "react-router-dom";

import ReactDOM from "react-dom/client";
import Popup from "./Components/BookingPopup";
import EmailTicket from "./EmailTicket";
import Invoice from "./Invoice";
import WebCheckin from "./WebCheckin";
import Swal from "sweetalert2";

import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import ReactDOMServer from "react-dom/server";
import TicketFormat from "./TicketFormat"; // adjust import as needed

import FailedBookingPopup from "./Components/FailedBookingPopup";
import { Call_Hold_and_Sell } from "../../../Utils/MyBookings_Func";
import { getLocalStorageJSON } from "../../../Utils/localStorageFunc";
import { MAIN_URL } from "../../../Configs/Urls";
import axios from "axios";
import toast from "react-hot-toast";
import moment from "moment";

function getStatusColor(status) {
  switch (status) {
    case "Ticket Pending":
      return "unsuccessful";
    case "Cancelled":
    case "Cancellation Requested":
    case "Rescheduling Requested":
    case "Refunded":
    case "Failed":
      return "cancelled";
    case "Completed":
    case "Confirmed":
      return "confirmed";
    default:
      return "unsuccessful";
  }
}

function MyFlightBookings() {
  let dispatch = useDispatch();

  const { isUserLogin, isAdminLogin, userLoggedInData } = useSelector(
    (state) => state.user
  );

  console.log("userLoggedInData is : ", userLoggedInData); // userid is avavailable at userLoggedInData.id

  let [FlightBookings, SetFlightBookings] = useState([]);

  useEffect(() => {
    const fetchFlightBookings = async () => {
      try {
        if (userLoggedInData?.id) {
          const response = await axios.get(
            `${MAIN_URL}bookings/flights/user/${userLoggedInData.id}`
          );
          console.log("Flight bookings:", response.data);
          SetFlightBookings(response.data); // update state with the response data
        }
      } catch (error) {
        console.error("Error fetching flight bookings:", error);
      }
    };

    fetchFlightBookings();
  }, [userLoggedInData?.id]); // run only when user ID is available

  const formatPriceWithCommas = (value) => {
    if (!value && value !== 0) return "0";
    const intValue = String(value).split(".")[0];
    return parseInt(intValue).toLocaleString("en-IN");
  };

  let [activeBookingHeader, setActiveBookingHeader] = useState("upcoming");

  let navigate = useNavigate();

  let proceedHoldBooking = () => {
    alert("proceed hold booking");
  };

  // Inside your component:
  let [OpenFailedBookingPopup, setOpenFailedBookingPopup] = useState(false);

  let [FailedBookingPopupData, setFailedBookingPopupData] = useState({
    hasError: false,
    return: false,
    Heading: "Loading",
    Message: "Please Wait We are Fetching your Booking's Data",
    showContinue: false,
    continueButtonText: "",
  });

  let closeTheFailedBookingPopup = () => {
    setOpenFailedBookingPopup(false);

    setFailedBookingPopupData({
      hasError: false,
      return: false,
      Heading: "Loading",
      Message: "Please Wait We are Fetching your Booking's Data",
      showContinue: false,
      continueButtonText: "",
    });
  };

  // Linked (rescheduled-into) bookings — a rescheduled booking creates a brand new booking record;
  // instead of showing that new booking as its own separate card, it's tucked under a "+N" expand
  // on the original card, and drilling in can chain further if THAT booking was also rescheduled.
  const [linkedPopupOpen, setLinkedPopupOpen] = useState(false);
  const [linkedChain, setLinkedChain] = useState([]);
  const [linkedBookings, setLinkedBookings] = useState([]);
  const [linkedLoading, setLinkedLoading] = useState(false);

  const fetchLinkedBookings = async (bookingId) => {
    setLinkedLoading(true);
    try {
      const res = await axios.get(
        `${MAIN_URL}bookings/flights/reschedule-children/${bookingId}`
      );
      setLinkedBookings(res.data || []);
    } catch (error) {
      console.error("Error fetching linked bookings:", error);
      setLinkedBookings([]);
    } finally {
      setLinkedLoading(false);
    }
  };

  const openLinkedBookings = (bookingId) => {
    setLinkedChain([bookingId]);
    setLinkedPopupOpen(true);
    fetchLinkedBookings(bookingId);
  };

  const drillIntoLinkedBookings = (bookingId) => {
    setLinkedChain((prev) => [...prev, bookingId]);
    fetchLinkedBookings(bookingId);
  };

  const goToLinkedBreadcrumb = (index) => {
    const newChain = linkedChain.slice(0, index + 1);
    setLinkedChain(newChain);
    fetchLinkedBookings(newChain[newChain.length - 1]);
  };

  const closeLinkedBookings = () => {
    setLinkedPopupOpen(false);
    setLinkedChain([]);
    setLinkedBookings([]);
  };

  let proceedFailedBooking = async (url, booking_id) => {
    console.log("url is : ", url); // debug from here

    Swal.fire({
      title: "You will be Re-Directed to Complete Your Booking",
      showCancelButton: true,
      confirmButtonText: "Confirm",
    }).then(async (result) => {
      if (result.isConfirmed) {
        setOpenFailedBookingPopup(true);
        setFailedBookingPopupData({
          hasError: false,
          return: false,
          Heading: "Loading",
          Message: "Please wait, we are fetching your booking data...",
          showContinue: false,
          continueButtonText: "",
        });

        const result = await Call_Hold_and_Sell(isUserLogin, url, booking_id);

        if (result.hasError === false) {
          setFailedBookingPopupData({
            hasError: false,
            return: false,
            Heading: "Booking Found Successfully",
            Message: "Please Wait , Returning you to Payment Gateway ...",
            showContinue: false,
            continueButtonText: "",
            onClickContinue: null,
          });

          // setOpenFailedBookingPopup(false); // close on success
        } else {
          setFailedBookingPopupData({
            hasError: true,
            return: result.return,
            Heading: result.Heading,
            Message: result.Message,
            showContinue: result.showContinue,
            continueButtonText: result.continueButtonText,
            onClickContinue: result.onClickContinue || null,
          });
        }
      }
    });
  };

  // const downloadTicket = async (data) => {
  //   try {
  //     toast.loading("Generating PDF...", { id: "pdf-download" });

  //     // Get the ticket element

  //     window.open a popup and create a temporary element <TicketFormat Data={data} />

  //     // then i think below line will work

  //     const ticketElement = document.querySelector(".air-ticket-view");

  //     if (!ticketElement) {
  //       console.error("Ticket element not found");
  //       toast.error("Ticket element not found", { id: "pdf-download" });
  //       return;
  //     }

  //     console.log("Found ticket element:", ticketElement);
  //     console.log("Element dimensions:", {
  //       width: ticketElement.offsetWidth,
  //       height: ticketElement.offsetHeight,
  //     });

  //     // Clone the element to avoid modifying the original
  //     const clonedElement = ticketElement.cloneNode(true);

  //     // Remove the back button from clone if it exists
  //     const backButton = clonedElement.querySelector(".back-arrow");
  //     if (backButton) {
  //       backButton.remove();
  //     }

  //     // Create a temporary container
  //     const tempContainer = document.createElement("div");
  //     tempContainer.style.position = "absolute";
  //     tempContainer.style.left = "0";
  //     tempContainer.style.top = "0";
  //     tempContainer.style.width = "1200px";
  //     tempContainer.style.background = "white";
  //     tempContainer.style.padding = "20px";
  //     tempContainer.style.zIndex = "-1";
  //     tempContainer.appendChild(clonedElement);
  //     document.body.appendChild(tempContainer);

  //     // Wait for fonts and images to load
  //     await document.fonts.ready;
  //     await new Promise((resolve) => setTimeout(resolve, 1500));

  //     console.log("Starting canvas generation...");

  //     // Generate canvas
  //     const canvas = await html2canvas(tempContainer, {
  //       scale: 2,
  //       useCORS: true,
  //       allowTaint: false,
  //       logging: true,
  //       backgroundColor: "#ffffff",
  //       width: tempContainer.offsetWidth,
  //       height: tempContainer.offsetHeight,
  //       windowWidth: tempContainer.offsetWidth,
  //       windowHeight: tempContainer.offsetHeight,
  //       onclone: (clonedDoc) => {
  //         console.log("Document cloned for rendering");
  //         const clonedContainer = clonedDoc.querySelector(".air-ticket-view");
  //         if (clonedContainer) {
  //           clonedContainer.style.display = "block";
  //           clonedContainer.style.visibility = "visible";
  //         }
  //       },
  //     });

  //     console.log("Canvas generated:", {
  //       width: canvas.width,
  //       height: canvas.height,
  //     });

  //     // Remove temporary container
  //     document.body.removeChild(tempContainer);

  //     if (canvas.width === 0 || canvas.height === 0) {
  //       throw new Error("Generated canvas is empty");
  //     }

  //     // Convert to PDF
  //     const imgData = canvas.toDataURL("image/png", 1.0);
  //     const pdf = new jsPDF("p", "mm", "a4");

  //     const pdfWidth = pdf.internal.pageSize.getWidth();
  //     const pdfHeight = pdf.internal.pageSize.getHeight();
  //     const canvasWidth = canvas.width;
  //     const canvasHeight = canvas.height;
  //     const ratio = canvasWidth / canvasHeight;
  //     const width = pdfWidth;
  //     const height = pdfWidth / ratio;

  //     let heightLeft = height;
  //     let position = 0;

  //     // Add first page
  //     pdf.addImage(imgData, "PNG", 0, position, width, height);
  //     heightLeft -= pdfHeight;

  //     // Add more pages if needed
  //     while (heightLeft > 0) {
  //       position = heightLeft - height;
  //       pdf.addPage();
  //       pdf.addImage(imgData, "PNG", 0, position, width, height);
  //       heightLeft -= pdfHeight;
  //     }

  //     // Save PDF
  //     const bookingId = data.Booking_id || "ticket";
  //     const fileName = `Ticket_${bookingId}_${moment().format("DDMMYYYY")}.pdf`;

  //     console.log("Saving PDF:", fileName);
  //     pdf.save(fileName);

  //     toast.success("PDF downloaded successfully!", { id: "pdf-download" });
  //   } catch (error) {
  //     console.error("Error generating PDF:", error);
  //     toast.error(`Failed to generate PDF: ${error.message}`, {
  //       id: "pdf-download",
  //     });
  //   }
  // };

  // Instead of manually linking CSS, copy all stylesheets
  const stylesheets = Array.from(document.styleSheets)
    .map((sheet) => {
      try {
        return Array.from(sheet.cssRules)
          .map((rule) => rule.cssText)
          .join("\n");
      } catch (e) {
        // Handle cross-origin stylesheets
        return "";
      }
    })
    .join("\n");

  const downloadTicket = async (data) => {
    let popup = null;
    let root = null;

    try {
      toast.loading("Generating PDF...", { id: "pdf-download" });

      // Open a popup window
      popup = window.open("", "_blank", "width=1200,height=800");

      if (!popup) {
        throw new Error("Popup blocked. Please allow popups for this site.");
      }

      // Setup the popup document
      popup.document.write(`
      <!DOCTYPE html>
      <html>
        <head>
          <title>Generating Ticket PDF...</title>
          <style>${stylesheets}</style>
        </head>
        <body>
          <div id="ticket-root"></div>
        </body>
      </html>
    `);
      popup.document.close();

      // Wait for popup to load
      await new Promise((resolve) => {
        if (popup.document.readyState === "complete") {
          resolve();
        } else {
          popup.addEventListener("load", resolve);
        }
      });

      // Render TicketFormat in the popup
      const container = popup.document.getElementById("ticket-root");
      root = ReactDOM.createRoot(container);

      await new Promise((resolve) => {
        root.render(<TicketFormat Data={data} nav={null} />);
        setTimeout(resolve, 1000); // Wait for render
      });

      // Wait for fonts and images
      await popup.document.fonts.ready;
      await new Promise((resolve) => setTimeout(resolve, 1500));

      // Get the ticket element from popup
      const ticketElement = popup.document.querySelector(".air-ticket-view");

      if (!ticketElement) {
        throw new Error("Ticket element not found in popup");
      }

      // Generate canvas from popup content
      const canvas = await html2canvas(ticketElement, {
        scale: 2,
        useCORS: true,
        allowTaint: false,
        logging: false,
        backgroundColor: "#ffffff",
        width: ticketElement.offsetWidth,
        height: ticketElement.offsetHeight,
        windowWidth: ticketElement.offsetWidth,
        windowHeight: ticketElement.offsetHeight,
      });

      if (canvas.width === 0 || canvas.height === 0) {
        throw new Error("Generated canvas is empty");
      }

      // Convert to PDF
      const imgData = canvas.toDataURL("image/png", 1.0);
      const pdf = new jsPDF("p", "mm", "a4");

      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = pdf.internal.pageSize.getHeight();
      const canvasWidth = canvas.width;
      const canvasHeight = canvas.height;
      const ratio = canvasWidth / canvasHeight;
      const width = pdfWidth;
      const height = pdfWidth / ratio;

      let heightLeft = height;
      let position = 0;

      // Add first page
      pdf.addImage(imgData, "PNG", 0, position, width, height);
      heightLeft -= pdfHeight;

      // Add more pages if needed
      while (heightLeft > 0) {
        position = heightLeft - height;
        pdf.addPage();
        pdf.addImage(imgData, "PNG", 0, position, width, height);
        heightLeft -= pdfHeight;
      }

      // Save PDF
      const bookingId = data.Booking_id || "ticket";
      const fileName = `Ticket_${bookingId}_${moment().format("DDMMYYYY")}.pdf`;
      pdf.save(fileName);

      toast.success("PDF downloaded successfully!", { id: "pdf-download" });
    } catch (error) {
      console.error("Error generating PDF:", error);
      toast.error(`Failed to generate PDF: ${error.message}`, {
        id: "pdf-download",
      });
    } finally {
      // Cleanup: close popup
      if (root) {
        root.unmount();
      }
      if (popup && !popup.closed) {
        popup.close();
      }
    }
  };

  let [openEmailTicketPopup, setOpenEmailTicketPopup] = useState(false);

  let [emailData, setEmailData] = useState(null);
  let closeTheEmailTicketPopup = () => {
    setEmailData(null);
    setOpenEmailTicketPopup(false);
  };

  let openTheEmailTicket = (data) => {
    setEmailData(data);
    setOpenEmailTicketPopup(true);
  };

  let [openInvoicePopup, setOpenInvoicePopup] = useState(false);

  let [invoiceData, setInvoiceData] = useState(null);

  let closeTheInvoicePopup = () => {
    setInvoiceData(null);
    setOpenInvoicePopup(false);
  };

  let openTheInvoice = (data) => {
    setInvoiceData(data);
    setOpenInvoicePopup(true);
  };

  let [openCheckinPopup, setOpenCheckinPopup] = useState(false);

  let [CheckinData, setCheckinData] = useState(null);
  let [CheckinLinks, setCheckinLinks] = useState(null);

  let closeTheCheckinPopup = () => {
    setCheckinData(null);
    setCheckinLinks(null);
    setOpenCheckinPopup(false);
  };

  let openTheWebCheckin = (links, data) => {
    setCheckinData(data);
    setCheckinLinks(links);
    setOpenCheckinPopup(true);
  };

  const printTicket = (data) => {
    const printWindow = window.open("", "_blank", "width=800,height=600");

    // Collect all stylesheets from the current document
    const styles = Array.from(document.styleSheets)
      .map((sheet) => {
        try {
          if (sheet.href) {
            return `<link rel="stylesheet" href="${sheet.href}" />`;
          } else if (sheet.ownerNode && sheet.ownerNode.innerHTML) {
            return `<style>${sheet.ownerNode.innerHTML}</style>`;
          }
        } catch (e) {
          console.warn("Style sheet couldn't be loaded:", e);
          return "";
        }
      })
      .join("\n");

    const htmlContent = `
      <html>
        <head>
          <title>Print Ticket</title>
          ${styles}
        </head>
        <body>
          <div id="print-ticket-root"></div>
          <script>
            window.onload = function () {
              setTimeout(() => {
                window.print();
                window.close();
              }, 1000);
            };
          </script>
        </body>
      </html>
    `;

    printWindow.document.write(htmlContent);
    printWindow.document.close();

    // Wait for window to finish loading before injecting React
    const interval = setInterval(() => {
      const rootEl = printWindow.document.getElementById("print-ticket-root");
      if (rootEl) {
        const root = ReactDOM.createRoot(rootEl);
        root.render(<TicketFormat Data={data} nav={null} />);
        clearInterval(interval);
      }
    }, 100);
  };

  return (
    <>
      <div className="myflight-bookings proxima_regular">
        {/* <h2>{reviewPageData.OpenPopupData?.Heading}</h2>
                {!Array.isArray(reviewPageData.OpenPopupData?.Data) ? (
                  <p>{reviewPageData.OpenPopupData?.Data}</p>
                ) : (
                  <div>
                    {reviewPageData.OpenPopupData?.Data.map((item, id) => {
                      return <div>{item.Message}</div>;
                    })}
                  </div>
                )} */}

        <div className="internal-tab-head">
          <div className="add-traveller-head">
            <h3 className="proxima_semibold">Flight Bookings</h3>
            <div className="flight-bookings-stepper">
              <ul className="flight-bookings-steppers-list">
                <li
                  className={`upcoming-userdb ${
                    activeBookingHeader == "upcoming"
                      ? "active-flight-booking-stepper"
                      : ""
                  }`}
                  onClick={() => setActiveBookingHeader("upcoming")}
                >
                  <h4 className="proxima_semibold">Upcoming</h4>
                  <span>{FlightBookings?.upcoming?.length} Booking</span>
                </li>
                <li
                  className={`unsuccessful-userdb ${
                    activeBookingHeader == "hold"
                      ? "active-flight-booking-stepper"
                      : ""
                  }`}
                  onClick={() => setActiveBookingHeader("hold")}
                >
                  <h4 className="proxima_semibold">Hold</h4>
                  <span>{FlightBookings?.hold?.length} Booking</span>
                </li>
                <li
                  className={`cancelled-userdb ${
                    activeBookingHeader == "cancelled"
                      ? "active-flight-booking-stepper"
                      : ""
                  }`}
                  onClick={() => setActiveBookingHeader("cancelled")}
                >
                  <h4 className="proxima_semibold">Modified</h4>
                  <span>{FlightBookings?.cancelled?.length} Booking</span>
                </li>
                <li
                  className={`completed-userdb ${
                    activeBookingHeader == "completed"
                      ? "active-flight-booking-stepper"
                      : ""
                  }`}
                  onClick={() => setActiveBookingHeader("completed")}
                >
                  <h4 className="proxima_semibold">Completed</h4>
                  <span>{FlightBookings?.completed?.length} Booking</span>
                </li>
                <li
                  className={`unsuccessful-userdb ${
                    activeBookingHeader == "unsuccessful"
                      ? "active-flight-booking-stepper"
                      : ""
                  }`}
                  onClick={() => setActiveBookingHeader("unsuccessful")}
                >
                  <h4 className="proxima_semibold">Unsuccessful</h4>
                  <span>{FlightBookings?.unsuccessful?.length} Booking</span>
                </li>
              </ul>
            </div>
          </div>
        </div>

        {/* // chekc booking id validation of acc to ticket / */}

        <ul className="my-bookings-list-userdb">
          {FlightBookings?.[activeBookingHeader]?.map((item, id) => {

        

            return (
              <li key={id}>
                <div className="userdb-mybookings-route">
                  <div className="left-userdb-mybookings-route">
                    <div className="plane-ico">
                      <img src={images["airline-ico.svg"]} alt="" />
                    </div>
                    <div className="booking-route-info">
                      <div className="top-booking-route-info">
                        <ul className="userdb-route-my-booking proxima_semibold">
                          <li>{item.from}</li>
                          <img src={images[item.arrow_icon]} />
                          <li>{item.to}</li>
                          <li
                            style={{ marginLeft: "10px" }}
                            className="proxima_regular color_light-gray-black"
                          >
                            {item.ViaCities.length > 0 && (
                              <>Via {item.ViaCities.join(", ")}</>
                            )}
                          </li>
                        </ul>
                      </div>
                      <div className="bottom-booking-route-info">
                        Booking ID: {item.booking_id}
                      </div>
                    </div>
                  </div>
                  <div className="right-userdb-mybookings-route">
                    <ul className="userdb-right-booking-info">
                      <li>
                        <h4 className="proxima_semibold">Trip Type</h4>
                        <span className="proxima_semibold">
                          {item.trip_type}
                        </span>
                      </li>
                      <li>
                        <h4 className="proxima_semibold">Booking Date</h4>
                        <span className="proxima_semibold">
                          {item.booking_date}
                        </span>
                      </li>
                      <li>
                        {item.current_status.status != "" && (
                          <>
                            <h4 className="proxima_semibold">Current Status</h4>
                            <span
                              className={`capital-status ${item.current_status.color}-color proxima_semibold`}
                            >
                              {item.current_status.status ==
                              "Hold : Ticket Pending"
                                ? "Booking Holded"
                                : item.current_status.status}
                            </span>
                          </>
                        )}
                      </li>
                    </ul>
                  </div>
                </div>

                <div className="airlines--stops--fares">
                  <div className="airbookings-content-wrapper">
                    {item.Data.map((itemm, id) => {
                      return (
                        <div className="airlines-data-userdb">
                          <div className="airline--info">
                            <AirlineLogos
                              length={itemm?.AirlineLogos?.length}
                              logos={itemm?.AirlineLogos}
                            />

                            <div className="airline--info--data">
                              <span
                                className="airline--name"
                                title={itemm.AirlineNames?.join(", ")}
                              >
                                {itemm.AirlineNames?.map(
                                  (item, id) =>
                                    `${item}${
                                      id !== itemm.AirlineNames?.length - 1
                                        ? ", "
                                        : ""
                                    }`
                                )}
                              </span>

                              <span
                                className="airline--code"
                                title={itemm.AirlineNoAndOperatingCarrier?.join(
                                  ", "
                                )}
                              >
                                {itemm.AirlineNoAndOperatingCarrier?.map(
                                  (item, id) =>
                                    `${item}${
                                      id !==
                                      itemm.AirlineNoAndOperatingCarrier
                                        ?.length -
                                        1
                                        ? ", "
                                        : ""
                                    }`
                                )}
                              </span>
                            </div>
                          </div>
                          <div className="route--timings">
                            <div className="from--route--timings">
                              <div className="top-from--route--timing">
                                <div className="route--timing proxima_semibold">
                                  {itemm.originTime}{" "}
                                  <span className="proxima_semibold">
                                    {itemm.originDate}
                                  </span>
                                </div>
                                <div
                                  className="route--from proxima_semibold"
                                  title={itemm.originInfo}
                                >
                                  {itemm.originInfo}
                                </div>
                              </div>
                            </div>
                            <div className="from-to--via--info">
                              <div className="route--timing--stops">
                                <div className="route--timing-top">
                                  <img src={images["timings-ico.svg"]} alt="" />
                                  {itemm.journeyTime}
                                </div>
                                <div className="route--timing-bottom">
                                  {itemm.stops}
                                </div>
                              </div>
                            </div>
                            <div className="to--route--timings">
                              <div className="top-to--route--timing">
                                <div className="route--timing proxima_semibold">
                                  {itemm.DesignationTime}{" "}
                                  <span className="proxima_semibold">
                                    {itemm.DesignationDate}
                                  </span>
                                </div>
                                <div
                                  className="route--from proxima_semibold"
                                  title={itemm.DesignationInfo}
                                >
                                  {itemm.DesignationInfo}
                                </div>
                              </div>
                            </div>
                            <div
                              className="to--route--timings"
                              style={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "flex-start",
                                justifyContent: "center",
                                height: "100%",
                              }}
                            >
                              {(item.current_status?.all_statuses?.length ?? 0) > 1 && itemm.Status?.map((i) => (
                                <span
                                  style={{ marginTop: "3px", cursor: "default" }}
                                  key={i}
                                  className={`capital-status ${getStatusColor(
                                    i
                                  )}-color proxima_semibold`}
                                  title={
                                    itemm.TravellerStatuses?.length
                                      ? `Travellers: ${itemm.TravellerStatuses.join(", ")}`
                                      : undefined
                                  }
                                >
                                  {i}
                                </span>
                              ))}
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>

                  <div className="airline--booking--fare">
                    <div className="airline--booking--internal--fare">
                      <div className="top--airline--fare proxima_bold">
                        <img src={images["rupee-mybooking.svg"]} alt="" />{" "}
                        {formatPriceWithCommas(item.price)}
                      </div>
                      <span>Travellers: {item.travellers}</span>
                    </div>

                    {item.current_status.status == "Hold : Ticket Pending" ||
                    item.current_status.status == "Hold Expired" ? (
                      <div
                        className="airline--booking--internal--view"
                        onClick={() => proceedHoldBooking()}
                      >
                        <a>Pay Now</a>
                      </div>
                    ) : item.current_status.status == "Failed" ? (
                      <div
                        className="airline--booking--internal--view"
                        onClick={() =>
                          proceedFailedBooking(item.url, item.booking_id)
                        }
                      >
                        <a>Proceed</a>
                      </div>
                    ) : (
                      item.current_status.status != "Ticket Pending" && (
                        <div
                          className="airline--booking--internal--view"
                          onClick={() =>
                            navigate(
                              `/user/myflightbookings/${item.booking_id}`
                            )
                          }
                        >
                          <a>View</a>
                        </div>
                      )
                    )}
                  </div>
                </div>
                {item.documents.length > 0 && (
                  <div className="mybookings--cta--list">
                    <ul className="mybookings--cta--list--internal">
                      {item.documents.map((document, id) => {
                        return (
                          <li
                            className={document.classname}
                            key={id}
                            onClick={() => {
                              console.log(
                                "document isndie her eis : ",
                                document.Data
                              );

                              if (document.action == "download") {
                                downloadTicket(document.Data.data);
                              } else if (document.action == "print") {
                                let DataToSend = item.documents.filter(
                                  (item) => item.name == "Download E-Ticket"
                                )[0].Data.data;
                                printTicket(DataToSend);
                              } else if (document.action == "email") {
                                let DataToSend = item.documents.filter(
                                  (item) => item.name == "Download E-Ticket"
                                )[0].Data.data;
                                openTheEmailTicket(DataToSend);

                                // openpopup // open the popup and sned email
                              } else if (
                                document.action == "popup" &&
                                document.name == "Invoice"
                              ) {
                                openTheInvoice(document.Data);
                                // openpopup // open the popup and sned email
                              } else if (document.action == "redirect") {
                                let DataToSend = item.documents.filter(
                                  (item) => item.name == "Download E-Ticket"
                                )[0].Data.data;

                                openTheWebCheckin(
                                  item.airline_websites,
                                  DataToSend
                                );

                                // openpopup // open the popup and sned email
                              }
                            }}
                          >
                            {document.name}
                          </li>
                        );
                      })}
                    </ul>
                  </div>
                )}

                {item.hold_end_time && (
                  <div className="hold-separator">
                    <div className="proxima_semibold font18">
                      Hold Price :{formatPriceWithCommas(item.hold_price)}
                    </div>
                    <Timer time={item.hold_end_time} />
                  </div>
                )}

                {item?.CancellationStatus &&
                  Object.entries(item.CancellationStatus)
                    .filter(([_, processes]) =>
                      processes.some(
                        (process) =>
                          process.status && process.status.trim().length > 0
                      )
                    )
                    .map(([tripName, processes]) => (
                      <div className="action-bottom-bar" key={tripName}>
                        <ul className="action-process-list">
                          {processes.map((process, index) => (
                            <li
                              key={index}
                              className={
                                process.isCompleted ? "" : "non-active-process"
                              }
                            >
                              {index == 0 && (
                                <h4 className="trip-title proxima_semibold">
                                  {tripName} :{" "}
                                </h4>
                              )}
                              <img
                                src={
                                  images[
                                    process.isCompleted
                                      ? index === 0
                                        ? "confirmed-cancel-icon.svg"
                                        : "cancel-number-2-confirmed-icon.svg"
                                      : index === 0
                                      ? "cancel-number-1-confirmed-icon.svg"
                                      : "cancel-number-2-non-confirmed-icon.svg"
                                  ]
                                }
                                alt=""
                              />

                              <div className="current-action-text">
                                <div className="process--title proxima_semibold">
                                  {process.val}
                                </div>

                                <p className="proxima_semibold">
                                  <span>Status:</span> {process.status || "-"}
                                </p>
                              </div>
                            </li>
                          ))}
                        </ul>
                      </div>
                    ))}

                {item.children_count > 0 && (
                  <div
                    className="linked-bookings-indicator"
                    style={{
                      padding: "10px 20px",
                      cursor: "pointer",
                      color: "#0d6efd",
                      fontWeight: 600,
                      textAlign: "center",
                      borderTop: "1px solid #eee",
                    }}
                    onClick={() => openLinkedBookings(item.booking_id)}
                  >
                    +{item.children_count} more booking
                    {item.children_count > 1 ? "s" : ""} linked to this booking
                  </div>
                )}
              </li>
            );
          })}
        </ul>



        <Popup
          Open={linkedPopupOpen}
          onClose={closeLinkedBookings}
          component={
            <div
              className="linked-bookings-popup"
              style={{ padding: "20px", minWidth: "480px", maxWidth: "700px" }}
            >
              <div
                style={{
                  display: "flex",
                  flexWrap: "wrap",
                  alignItems: "center",
                  gap: "6px",
                  marginBottom: "16px",
                  fontWeight: 600,
                }}
              >
                {linkedChain.map((bId, idx) => (
                  <React.Fragment key={bId + idx}>
                    <span
                      style={{
                        cursor:
                          idx === linkedChain.length - 1
                            ? "default"
                            : "pointer",
                        color:
                          idx === linkedChain.length - 1 ? "#000" : "#0d6efd",
                      }}
                      onClick={() =>
                        idx !== linkedChain.length - 1 &&
                        goToLinkedBreadcrumb(idx)
                      }
                    >
                      {bId}
                    </span>
                    {idx !== linkedChain.length - 1 && <span>{">"}</span>}
                  </React.Fragment>
                ))}
              </div>

              {linkedLoading ? (
                <div>Loading...</div>
              ) : linkedBookings.length === 0 ? (
                <div>No linked bookings found.</div>
              ) : (
                <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
                  {linkedBookings.map((b, idx) => (
                    <li
                      key={idx}
                      style={{
                        border: "1px solid #e2e8f0",
                        borderRadius: "8px",
                        padding: "12px 16px",
                        marginBottom: "10px",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                        }}
                      >
                        <div>
                          <div style={{ fontWeight: 700 }}>
                            {b.from} → {b.to}
                          </div>
                          <div style={{ fontSize: "12px", color: "#666" }}>
                            Booking ID: {b.booking_id}
                          </div>
                        </div>
                        <span
                          className={`capital-status ${b.current_status?.color}-color proxima_semibold`}
                        >
                          {b.current_status?.status}
                        </span>
                      </div>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          marginTop: "8px",
                        }}
                      >
                        <div
                          style={{
                            color: "#0d6efd",
                            cursor: "pointer",
                            fontWeight: 600,
                          }}
                          onClick={() => {
                            closeLinkedBookings();
                            navigate(
                              `/user/myflightbookings/${b.booking_id}`
                            );
                          }}
                        >
                          View
                        </div>
                        {b.children_count > 0 && (
                          <div
                            style={{
                              color: "#0d6efd",
                              cursor: "pointer",
                              fontWeight: 600,
                            }}
                            onClick={() =>
                              drillIntoLinkedBookings(b.booking_id)
                            }
                          >
                            +{b.children_count} more booking
                            {b.children_count > 1 ? "s" : ""} →
                          </div>
                        )}
                      </div>
                    </li>
                  ))}
                </ul>
              )}
            </div>
          }
        />

        <Popup
          Open={openEmailTicketPopup}
          onClose={closeTheEmailTicketPopup}
          component={
            <EmailTicket Data={emailData} onClose={closeTheEmailTicketPopup} />
          }
        />

        <Popup
          Open={openCheckinPopup}
          onClose={closeTheCheckinPopup}
          component={
            <WebCheckin
              Data={CheckinData}
              links={CheckinLinks}
              onClose={closeTheCheckinPopup}
            />
          }
        />

        <Popup
          Open={OpenFailedBookingPopup}
          onClose={null}
          component={
            <FailedBookingPopup
              Data={FailedBookingPopupData}
              onClose={closeTheFailedBookingPopup}
            />
          }
        />

        <Popup
          Open={openInvoicePopup}
          onClose={closeTheInvoicePopup}
          component={
            <Invoice Data={invoiceData} onClose={closeTheInvoicePopup} />
          }
        />
      </div>
    </>
  );
}

export default MyFlightBookings;



